(function ($) {
  var $body = $("body"),
    $doc = $(document),
    $html = $("html"),
    $win = $(window);

  $doc.ready(function () {
    theme.init();
  });

  var theme = {
    init: function () {
      this.initSlideshowCustom();
      // this.initSplashScreen();
      if($body.hasClass('template-product')) {
        this.initATCMenuMObile();
        this.initTabNav();
        this.initClickzoom();
      }
    },
    initClickzoom: function() {

        $('button.product-gallery__zoom-button').click(function() {
          $('.product-gallery__thumbnail-list').addClass('is-active'); // Set the style when the button is off
          $('button[aria-controls="sidebar-menu"]').addClass('is-active');
          $('#header-search').addClass('is-active');
          $('#header-cart').addClass('is-active');
          $('wishlist-link').addClass('is-active');
          $('.product-gallery__image-list').addClass('is-active');
          $('button[aria-controls="zoom"]').show();
          $('button.product-gallery__zoom-button').hide();
          $('html, body').animate({ scrollTop: 0 }, 'slow');
          $("body").css("overflow", "hidden");
        });
       $('button[aria-controls="zoom"]').click(function() {
          $('button[aria-controls="sidebar-menu"]').removeClass('is-active');
          $('.product-gallery__thumbnail-list').removeClass('is-active'); 
          $('#header-search').removeClass('is-active');
          $('#header-cart').removeClass('is-active');
          $('wishlist-link').removeClass('is-active'); 
         $('.product-gallery__image-list').removeClass('is-active');
         $('button[aria-controls="zoom"]').hide();
         $('button.product-gallery__zoom-button').show();
          $("body").css("overflow", "auto");
       });
          $('.product-gallery__thumbnail').click(function() {
          $('button[aria-controls="sidebar-menu"]').removeClass('is-active');
          $('.product-gallery__thumbnail-list').removeClass('is-active'); 
          $('#header-search').removeClass('is-active');
          $('#header-cart').removeClass('is-active');
          $('wishlist-link').removeClass('is-active');
         $('.product-gallery__image-list').removeClass('is-active');
         $('button[aria-controls="zoom"]').hide();
         $('button.product-gallery__zoom-button').show();
          $("body").css("overflow", "auto");
       });
    },
    initSlideshowCustom: function() {
      var slideshow = $('slideshow-custom');

      if(slideshow.length > 0) {
        slideshow.each(function(){
          $(this).slick({
            infinite: true,
            autoplay: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '300px',
            arrows: false,
            dots: true,
            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="11.354" height="17.996" viewBox="0 0 11.354 17.996"><g transform="translate(0)"><path d="M4.668,10.987H2.4L0,.009,2.432,0Z" transform="translate(8.292 0) rotate(49)" fill="#221714"/><rect width="1.133" height="11.761" transform="translate(10.035 17.252) rotate(139)" fill="#221714"/></g></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="11.354" height="17.996" viewBox="0 0 11.354 17.996">  <g transform="translate(11.354 17.996) rotate(180)"><path d="M4.668,10.987H2.4L0,.009,2.432,0Z" transform="translate(8.292 0) rotate(49)" fill="#221714"/><rect width="1.133" height="11.761" transform="translate(10.035 17.252) rotate(139)" fill="#221714"/></g></svg></button>',
            responsive: [
              {
                breakpoint: 1800,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '150px',
                  arrows: false,
                  dots: true,
                  autoplay: true
                }
              },
              {
                breakpoint: 1025,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '100px',
                  arrows: false,
                  dots: true,
                  autoplay: true
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '15%',
                  arrows: false,
                  dots: true,
                  autoplay: true
                }
              }
            ]
          })
          // slick
        })
        // each
      }
    },

    initSplashScreen: function() {
      // var splashScreen = document.querySelector('.splash');
      // setTimeout(()=>{
      //     splashScreen.classList.add('hidden')
      //   },5000)
    
    },

    initATCMenuMObile: function() {
      const $buttonShowPopup = $('[data-atc-popup]'),
      $thisPopup = $('.product_express--wrapper');

      $buttonShowPopup.on('click', (event) => {
        $thisPopup.addClass('is-show');
        $body.addClass('is-show')
        $('.PageOverlay').addClass('is-visible');
      })

      $(document).on('click', '[data-close-atc-popup],.PageOverlay', () => {
        $thisPopup.removeClass('is-show');
        $body.removeClass('is-show')
        $('.PageOverlay').removeClass('is-visible');
      });
    },

    initTabNav: function() {
      // Declare all variables
      var i, tabcontent, tablinks;
      tablinks = document.getElementsByClassName("tablinks");
      
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].addEventListener("click", (evt) => {
          evt.preventDefault();

          // Get all elements with class="tabcontent" and hide them
          tabcontent = document.getElementsByClassName("tabcontent");
          for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
          }
           for (j = 0; j < tablinks.length; j++) {
            // Get all elements with class="tablinks" and remove the class "active"
            tablinks[j].className = tablinks[j].className.replace(" active", "");
           }
            
          // Show the current tab, and add an "active" class to the button that opened the tab
          document.getElementById(evt.target.attributes['data-tab'].value).style.display = "block";
          evt.currentTarget.className += " active";
        })
      }

    }
  }

  // filter blog style
  $(".c-blog-style__filter .c-blog-style__filter-inner").removeClass("u--filter-show");
  $(".c-blog-style__filter .c-blog-style__filter__title").removeClass("u--filter-show");
  $(window).click(function() {
    $(".c-blog-style__filter .c-blog-style__filter-inner").removeClass("u--filter-show");
    $(".c-blog-style__filter .c-blog-style__filter__title").removeClass("u--filter-show");
  });
  $(".c-blog-style__filter .c-blog-style__filter__title").click(function () {
    event.stopPropagation();
    $(this).toggleClass("u--filter-show");
    $(".c-blog-style__filter .c-blog-style__filter-inner").toggleClass("u--filter-show");
  });
  $(".c-blog-style__filter .c-blog-style__filter-label").click(function(){
    event.stopPropagation();
    $(this).next(".c-blog-style__filter .c-blog-style__filter-list-tag").slideToggle(300);
    $(this).toggleClass("u--rotage-icon");
  });

  // pagination
  var paramVal = $(".pagination .pagination__link[aria-current='page']");
  var paramCurrent = $(".pagination .pagination__link[aria-current='page'] span");
  var paramVal1 = $(".pagination .pagination__link.c-paginate-item");
  var newElement = $('<span class="u--next" style="line-height: 42px; text-align: center;">...</span>');
  var newElement1 = $('<span class="u--pre" style="line-height: 42px; text-align: center;">...</span>');
  var currentPage = paramCurrent.text();
  var totalItemPaginate = $(".pagination").attr("total-item");
  paramVal.before(newElement1);
  paramVal.after(newElement);
  paramVal1.each(function (index) {
    var itemPaginate = $(this).text();
    var lasitemPagi = index +1;
    if ((itemPaginate > 1) && (itemPaginate < currentPage)) {
      $(this).css("display", "none");
    }
    if ((itemPaginate > currentPage) && (itemPaginate < totalItemPaginate)) {
      $(this).css("display", "none");
    }

  });
  if(currentPage == "2"){
    $(".u--pre").css("display", "none");
  }
  if(currentPage == (totalItemPaginate - 1)){
    $(".u--next").css("display", "none");
  }
  if (currentPage == 1) {
    $(".u--pre").css("display", "none");
  }
  if (currentPage == totalItemPaginate) {
    $(".u--next").css("display", "none");
  }
  
  var policyParam = $(".shopify-policy__container .shopify-policy__title h1");
  console.log(policyParam.text());
  if(policyParam.text() == "プライバシーポリシー"){
    policyParam.text("PRIVACY POLICY");
  }else if (policyParam.text() == "利用規約"){
    policyParam.text("TERMS");
  }
  
})(jQuery);
